import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import Listings from './Components/Listings';
import Agencies from './Components/Agencies';
import AddProperty from './Components/AddProperty';
import Signup from './Components/Signup';
import Login from './Components/Login';
import ForgotPassword from './Components/ForgotPassword';
import VerifyEmail from './Components/VerifyEmail';
import ResetPassword from './Components/ResetPassword';
import Profile from './Components/Profile';
import './App.css';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import AgencyDetail from './Components/AgencyDetail';
import ListingDetail from './Components/ListingDetail';
import ListingUpdate from './Components/ListingUpdate';
import WarningModal from './Components/WarningModal'; // Adjust the path as needed


// Import ThemeProvider and createTheme
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Create a theme
const theme = createTheme();

function App() {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Show the warning modal only once per session
    const hasSeenWarning = sessionStorage.getItem('hasSeenWarning');
    if (!hasSeenWarning) {
      setShowWarning(true);
      sessionStorage.setItem('hasSeenWarning', true);
    }
  }, []);

  const handleCloseWarning = () => {
    setShowWarning(false);
  };

  return (
    // Wrap the entire app in ThemeProvider and pass the theme object
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastContainer />
      <WarningModal open={showWarning} onClose={handleCloseWarning} />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/listings' element={<Listings />} />
          <Route path='/agencies' element={<Agencies />} />
          <Route path='/add-property' element={<AddProperty />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/login' element={<Login />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/otp-verify' element={<VerifyEmail />} />
          <Route path='/password-reset-confirm/:uid/:token' element={<ResetPassword />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/agency/:id' element={<AgencyDetail />} />
          <Route path='/listing/:id' element={<ListingDetail />} />
          <Route path='/listing-update' element={<ListingUpdate />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;

// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Home from './Components/Home';
// import Listings from './Components/Listings';
// import Agencies from './Components/Agencies';
// import AddProperty from './Components/AddProperty';
// import Signup from './Components/Signup';
// import Login from './Components/Login';
// import ForgotPassword from './Components/ForgotPassword';
// import VerifyEmail from './Components/VerifyEmail';
// import ResetPassword from './Components/ResetPassword';
// import Profile from './Components/Profile';
// import './App.css';
// import { CssBaseline } from '@mui/material';
// import { ToastContainer } from 'react-toastify';
// import "react-toastify/dist/ReactToastify.css";
// import AgencyDetail from './Components/AgencyDetail';
// import ListingDetail from './Components/ListingDetail';

// function App() {
//   return (
//     <BrowserRouter>
//       <CssBaseline/>
//       <ToastContainer />
//       <Routes>
//         <Route path='/' element={<Home/>} />
//         <Route path='/listings' element={<Listings/>} />
//         <Route path='/agencies' element={<Agencies/>} />
//         <Route path='/add-property' element={<AddProperty/>} />
//         <Route path='/signup' element={<Signup/>} />
//         <Route path='/login' element={<Login/>} />
//         <Route path='/forgot-password' element={<ForgotPassword/>} />
//         <Route path='/otp-verify' element={<VerifyEmail/>} />
//         <Route path='/password-reset-confirm/:uid/:token' element={<ResetPassword/>} />
//         <Route path='/profile' element={<Profile/>} />
//         <Route path='/agency/:id' element={<AgencyDetail/>} />
//         <Route path='/listing/:id' element={<ListingDetail/>} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;
